import moment from 'moment';

function momentLocal(value, format) {
    if (value)
        return moment.utc(value).local().format(format);
}

function momentUtc(value, format) {
    if (value)
        return moment.utc(value).format(format);
}

function momentCalendar(value, options) {
    if (value) {
        let formats = { sameElse: 'M/D/YY' };
        if (options)
            Object.assign(formats, options);

        return moment.utc(value).local().calendar(null, formats);
    }
}

function momentFromNow(value) {
    if (value)
        return moment.utc(value).local().fromNow();
}

function momentDifference(value, now) {
    if (value && now) {
        let duration = moment.duration(Math.abs(moment.utc(value).diff(now)));
        let seconds = duration.seconds();
        let minutes = duration.minutes();
        let hours = duration.hours();
        let days = Math.floor(duration.asDays());

        // Add leading zeros
        seconds = ('0' + seconds).substr(-2);
        if (days || hours)
            minutes = ('0' + minutes).substr(-2);

        if (days)
            return `${days}d ${hours}h ${minutes}m ${seconds}s`;
        if (hours)
            return `${hours}h ${minutes}m ${seconds}s`;
        return `${minutes}m ${seconds}s`;
    }
}

export default {
    install(Vue, options) {
        Vue.filter('moment', momentLocal);
        Vue.filter('moment.utc', momentUtc);

        Vue.filter('moment.calendar', momentCalendar);

        Vue.filter('moment.fromNow', momentFromNow);

        Vue.filter('date', value => momentLocal(value, 'MMMM Do, YYYY'));
        Vue.filter('date.utc', value => momentUtc(value, 'MMMM Do, YYYY'));
        Vue.filter('dateTime', value => momentLocal(value, 'MMMM Do YYYY, h:mm a'));
        Vue.filter('dateTimeSeconds', value => momentLocal(value, 'MMMM Do YYYY, h:mm:ss a'));
        Vue.filter('shortDateTime', value => momentLocal(value, 'M/D/YY, h:mm a'));
        Vue.filter('shortDateTimeSeconds', value => momentLocal(value, 'M/D/YY, h:mm:ss a'));

        Vue.filter('difference', (value, now) => momentDifference(value, now));
    },
};
